<template>
 <div style="height:100%;width:100%;">   
    <van-row  type="flex" style="height:100%;" rank='y'
        v-if="root.device!='phone'"
            class="device_pc fs16"
    >
        <van-row flex='3' style="margin-top:-0.5vw">
            <div class='wrapper'>
             <cusbox txt="样品开发进度节点"> 
           
                 <van-row type='flex' style="height:100%;" rank='y' v-if="JSON.stringify(designlist)!='[]'">
                    <van-row type='flex' flex='1' class="myinfo" v-for="(item,index) in designlist" :key="index">
                        <van-col class="left">
                             <van-row type='flex' class="touxiao">
                               <van-row type='flex' class="info_left" rank='y' align='center'>                                 
                                  <img  :src="item.image">
                                  <van-row flex='1' rank='y' type='flex' style="justify-content: flex-end;">                                 
                                    <div>
                                        设计师
                                    </div>
                                    <div class="hb"></div>
                                    <div>
                                        {{item.designer}}
                                    </div>
                                  </van-row>
                               </van-row>
                               <van-row type='flex'  class="info_right" flex='1' rank='y'>
                                   <van-row class="rowbtm" flex='1' type="flex">款式样品：</van-row>
                                   <van-row class="rowbtm" flex='1' type="flex">{{item.code}}</van-row>
                                   <van-row class="rowbtm" flex='1' type="flex">款式:{{item.codeName}}</van-row>
                                   <van-row class="rowbtm" flex='1' type="flex">开发类型:{{item.developmentType}}</van-row>
                                   <van-row class="rowbtm" flex='1' type="flex">开发模式:{{item.devlop_model}}</van-row>
                                   <van-row class="rowbtm" flex='1' type="flex">样品加工类型:{{item.processingMode}}</van-row>
                                   <van-row class="rowbtm" flex='1' type="flex">颜色/尺码/数量:{{item.color}}/{{item.size}}/{{item.requestedQty}}</van-row>
                                   <van-row class="rowbtm" flex='1' type="flex">设计需求时间:{{item.demandTime.split(' ')[0]}}</van-row>
                               </van-row>
                             </van-row>
                        </van-col>
                        <van-col flex='1'  class="right">
                               <van-row type='flex' class="xline" >
                                   <van-row type='flex' flex='1' rank='y' v-for="(item2,index2) in item.nodeList" :key="index2">
                                         <van-row flex='1' type='flex' justify='center' >
                                            {{item2.nodeName}}
                                        </van-row>
                                         <van-row flex='1' type='flex' justify='center'  align="center" style="text-align:center;">
                                            {{timestampToTime(Math.round(new Date(item2.timeUp) / 1000))}}
                                        </van-row>   
                                        <van-row flex='1' type='flex' align='center' :class="Math.round(new Date(item2.timeUp) / 1000)>Math.round(new Date(item2.timeDown) / 1000)?'blue':''">
                                            <div class="yuan_line" flex='1' v-if="index2>0"></div>  
                                            <div class="yuan_line2" flex='1' v-else></div>  
                                           <div class="yuan">-</div>    
                                           <div class="yuan_line" flex='1' v-if="index2<item.nodeList.length-1"></div>
                                           <div class="yuan_line2" flex='1' v-else></div>  
                                        </van-row>  
                                        <van-row flex='1' type='flex' justify='center'  align="center" style="text-align:center;">
                                            {{timestampToTime(Math.round(new Date(item2.timeDown) / 1000))}}
                                        </van-row>  
                                   </van-row>
                                   
                                   
                               </van-row>
                        </van-col>
                    </van-row>
                    
                 </van-row>
                 <dv-loading v-else>Loading...</dv-loading>
             </cusbox>
            </div>
        </van-row>
        <van-row flex='1.5' type="flex">
            <van-col flex='1'>
                <div class='wrapper'>
                    <cusbox txt="样衣批次出款完成率 TOP50"> 
                         <div class="tablewrapper"> 
                        <itemlist 
                            v-if="getSampleBatchPaymentCompletionRateShow"
                           :count='4'
                           :columns='columns1'
                           :data='data1'                    
                        />
                        <dv-loading v-else>Loading...</dv-loading>
                         </div>
                    </cusbox>
                </div>
            </van-col>
            <van-col  flex='1'>
                <div class='wrapper'>
                    <cusbox txt="设计师开发成功率 TOP10"> 
                         <div class="tablewrapper"> 
                         <itemlist 
                    v-if="getSuccessRateOfDesignerDevelopmentShow"
                      :count='4'
                      :columns='columns2'
                      :data='data2'                    
                   />
                   <dv-loading v-else>Loading...</dv-loading>
                         </div>
                    </cusbox>
                </div>
            </van-col>
        </van-row>
    </van-row>

       <mobile class="device_phone ppd notransform" v-else>
            <div style="height:1250px;margin-top:10px;">
                <cusbox txt="样品开发进度节点"  v-if="JSON.stringify(designlist)!='[]'"> 
                    <layout type="T_B"  class="jd_all"  v-for="(item,index) in designlist" :key="index" >
                        <layout type="L_R" flex=1 style="margin-top:10px;height:150px;margin-bottom:10px">
                             <layout type="T_B" style="flex:none;padding:0px 10px;text-align:center">
                                    <img  style="width:90px;height:110px;display:block" :src="item.pics">
                                    <layout type="T_B">
                                     <div>
                                        设计师
                                    </div>  
                                     <div>
                                        {{item.designer}}
                                    </div>
                                    </layout>
                             </layout>  

                             <layout type="T_B">
                                  <div flex=1>款式样品：{{item.code}}</div>
                                  <div flex=1>款式：{{item.codeName}}</div>
                                  <div flex=1>开发类型：{{item.developmentType}}</div>
                                  <div flex=1>开发模式：{{item.devlop_model}}</div>
                                  <div flex=1>样品加工类型：{{item.devlop_model}}</div>
                                  <div flex=1>颜色/尺码/数量：{{item.color}}/{{item.size}}/{{item.requestedQty}}</div>
                                  <div flex=1>设计需求时间：{{item.demandTime.split(' ')[0]}}</div>
                             </layout>                          
                        </layout>
               
                         <div class="jd_line">
                             <layout type="T_B" v-for="(item2,index2) in item.nodeList" :key="index2"  :class="Math.round(new Date(item2.timeUp) / 1000)>Math.round(new Date(item2.timeDown) / 1000)?'blue':''" style="margin-bottom:10px">
                                 <div class="jd_line_name">{{item2.nodeName}}</div>
                                 <div class="jd_line_time">{{timestampToTime(Math.round(new Date(item2.timeUp) / 1000))}}</div>
                                 <layout type="L_R" >
                                     <cell flex=1 v-if="index2>0"><div class="jd_line_left"></div></cell>
                                     <cell flex=1 v-else></cell>
                                    <div class="jd_yuan">-</div>
                                    <cell  flex=1 v-if="index2<item.nodeList.length-1"><div class="jd_line_right"></div></cell>
                                    <cell flex=1 v-else></cell>
                                 </layout>
                                 <div>
                                      {{timestampToTime(Math.round(new Date(item2.timeDown) / 1000))}}
                                 </div>
                             </layout>
                        </div>
                    </layout>
                    
             </cusbox>
<dv-loading v-else>Loading...</dv-loading>
            </div>
             <div style="height:250px;margin-top:10px;">
                    <cusbox txt="样衣批次出款完成率 TOP50"> 
                         <div class="tablewrapper"> 
                        <itemlist
                         v-if="getSampleBatchPaymentCompletionRateShow" 
                      :count='4'
                      :columns='cols_1'
                      :data='data1'                    
                   />
                   <dv-loading v-else>Loading...</dv-loading>
                         </div>
                    </cusbox>
             </div>

              <div style="height:250px;margin-top:10px;">
                    <cusbox txt="设计师开发成功率 TOP10"> 
                         <div class="tablewrapper"> 
                         <itemlist 
                         v-if="getSuccessRateOfDesignerDevelopmentShow"
                      :count='4'
                      :columns='cols_2'
                      :data='data2'                    
                   />
                   <dv-loading v-else>Loading...</dv-loading>
                         </div>
                    </cusbox>
              </div>
           
       </mobile>
 </div>
</template>
<script>
import cell from "@/components/cuscom/cell.vue";
import layout from "@/components/cuscom/layout.vue"
import cusbox from "@/components/vip/cusbox"
import itemlist from "@/components/cuscom/itemlist"
import mobile from "../common/mobile.vue";
import {cols_1,cols_2} from "./device/phone_column.js"

export default {
      inject:['root'],
    components:{
        cusbox,
        itemlist,
        mobile,
        layout,
        cell
    },        
    data(){
        return {
            cols_1,cols_2,
            columns1:[
                {
                    title:"排名",
                    key:'rank',                   
                    align:"center",                   
                    width:'2.5vw',                   
                },
                {
                    title:"季节",
                    key:'seasonLogo'    ,
                     width:'8vw',
                      align:"center", 
                },
                {
                    title:"批次",
                    key:'batch',
                    align:"center"      
                },
                {
                    title:"SKC数",
                    key:'skcNum',
                    align:"center",        
                },
                {
                    title:"有效款",
                    key:'activeNum',
                    align:"center",        
                },
                {
                    title:"已出版单总数",
                    key:'patActualFinishNum',
                    align:"center",        
                },
                {
                    title:"出款完成率",
                    key:'finshRate',
                    align:"center",        
                }         
            ],
            columns2:[
                {
                    title:"排名",
                    key:'rank',                   
                    align:"center",                   
                    width:'5vw',                   
                },
                {
                    title:"设计师",
                    key:'designer',
                     align:"center",     
                },
                {
                    title:"商品总需求",
                    key:'total',
                    align:"center"      
                },
                {
                    title:"已出款总数",
                    key:'outTotal',
                    align:"center",        
                },
                {
                    title:"出款完成率",
                    key:'outRate',
                    align:"center",        
                },
                {
                    title:"有效配色数",
                    key:'activeTotal',
                    align:"center",        
                },
                {
                    title:"配色确认投产数",
                    key:'colorTotal',
                    align:"center",        
                },
                {
                    title:"投产配色成功率",
                    key:'colorRate',
                    align:"center",        
                }     
            ],
            data1:[],
            getSampleBatchPaymentCompletionRateShow:false,
            getSuccessRateOfDesignerDevelopmentShow:false,
            data2:[],
            api:this.$apis['design'],
            designlist:[],
            list:[],
             timer:false,
        }
    },
    mounted(){ 
       this.getdata()
    },
        beforeDestroy: function() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
    methods:{
        getdata(){
        
            //设计师列表
            this.api.getSampleDevelopmentProgressNode().then(res=>{      
                this.list=res.data.list;               
                // nlist.forEach((item,index)=>{  
                //     item.itemlist.forEach((item2,index2)=>{
                //       item2.name=`员工1${index2}`
                //     })
                // })
                // this.list=nlist;            
                this.doin();
            })
            //样衣批次出款完成率 TOP50
            this.api.getSampleBatchPaymentCompletionRate().then(res=>{   
                let that = this
                this.getSampleBatchPaymentCompletionRateShow = true
                setTimeout(function(){
                    that.data1=res.data.list
                },0)   
                
            })
             //设计师开发成功率 TOP10
            this.api.getSuccessRateOfDesignerDevelopment().then(res=>{        
                 let that = this
                this.getSuccessRateOfDesignerDevelopmentShow = true
                setTimeout(function(){
                    that.data2=res.data.list
                },0)   
            })
      
        },
        rundata(){
            this.list.push(this.list.shift()) ;  
            this.designlist=this.list.slice(0,2)
            
        },
        doin(){            
             if(this.timer){
                window.clearInterval(this.timer);
            }           
             this.timer= setInterval(()=>{             
                this.rundata()
            },3000)       
          
        },
           
        timestampToTime(timestamp) {
            
      var date = new Date(Number(timestamp)*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
      
      var strDate = Y+M+D;
     
      return timestamp?strDate:'-';//2020-07-30 01:05:54
    }
    }
}
</script>
<style lang="scss" scoped>
   @import './device/pc.scss';
  @import './device/phone.scss';
  .notransform{
      .jd_all{
          color:#fff;
      }
        .jd_line{
            text-align: center;
            .jd_line_name{
                overflow: hidden;
                height: 40px;
            }
            &>div {width:25%;float: left;overflow: hidden;}
           
            .blue{
                .jd_yuan{ 
                      color: #48a0ee;
                      border: 2px solid #48a0ee;
                }
               .jd_line_left{
                    flex: 1;
                    border-top:1px solid #48a0ee;
                }
                .jd_line_right{
                    flex: 1;
                    border-top:1px solid #48a0ee;
                }
            }
               .jd_line_left{
                flex: 1;
                border-top:1px solid #ef4f7d;
            }
            .jd_line_right{
                flex: 1;
                border-top:1px solid #ef4f7d;
            }    
            .jd_yuan{             
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    color: #ef4f7d;
                     margin: 5px 0px;
                     border: 2px solid #ef4f7d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
            }
        }
  }
</style>